import React from 'react';

import classNames from 'classnames';

interface Props {
  className?: string;
  text?: React.ReactNode;
  fontSize?: number;
  color?: string;
  icon?: React.ReactNode;
  textClassName?: string;
}

function Pills(props: Props) {
  const { className, text, fontSize = 8, color, icon, textClassName } = props;

  return (
    <div className={classNames('expired-pills', className)}>
      {/* @ts-expect-error -- keeping existing non-standard DOM props */}
      <span className={textClassName} fontSize={fontSize} color={color}>
        {text}
      </span>
      {icon && icon}
    </div>
  );
}

export default Pills;
